import { expVal } from '@atlassian/jira-feature-experiments';

const GroupByAgentSessionsSubPropertyExperimentRelayProvider = {
	get(): boolean {
		return expVal('group_by_agent_sessions_sub_property_experiment', 'isEnabled', false);
	},
};

export default GroupByAgentSessionsSubPropertyExperimentRelayProvider;
